import { Col, Form, Input, Row } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import BusinessRulesViewer from ".././BusinessRulesViewer/BusinessRulesViewer";

const FormDetailViewer = () => {
    const currentBaseName = useSelector((state: any) => state.pickAFile.baseName);
    const currentAddressStart = useSelector((state: any) => state.pickAFile.addressStart);
    const currentAddressEnd = useSelector((state: any) => state.pickAFile.addressEnd);
    const currentFormName = useSelector((state: any) => state.pickAFile.formName);
    const currentInterfaceId = useSelector((state: any) => state.pickAFile.interfaceId);
    const currentAssistanceFormId = useSelector((state: any) => state.pickAFile.assistanceFormId);
    const currentFormDescription = useSelector((state: any) => state.pickAFile.formDescription);
    const currentFormRuleSetId = useSelector((state: any) => state.pickAFile.formRuleSetId);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    const onAddressStartChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setAddressStart, payload: parseInt(event.target.value) });
        CreateContentsFromStates({ addressStart: parseInt(event.target.value) });
    }

    const onAddressEndChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setAddressEnd, payload: parseInt(event.target.value) });
        CreateContentsFromStates({ addressEnd: parseInt(event.target.value) });
    }

    const onBaseNameChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setBaseName, payload: event.target.value });
        CreateContentsFromStates({ baseName: event.target.value });
    }

    const onInterfaceIdChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setInterfaceId, payload: parseInt(event.target.value) });
        CreateContentsFromStates({ interfaceId: parseInt(event.target.value) });
    }

    const onAssistanceFormIdChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setAssistanceFormId, payload: parseInt(event.target.value) });
        CreateContentsFromStates({ assistanceFormId: parseInt(event.target.value) });
    }

    const onFormNameChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setFormName, payload: event.target.value });
        CreateContentsFromStates({ formName: event.target.value });
    }

    const onFormDescriptionChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setFormDescription, payload: event.target.value });
        CreateContentsFromStates({ formDescription: event.target.value });
    }

    const onFormRuleSetIdChange = (event) => {
        dispatch({ type: pickAFileSliceDispatch.setFormRuleSetId, payload: parseInt(event.target.value) });
        CreateContentsFromStates({ formRuleSetId: parseInt(event.target.value) });
    }

    const formDetails =
        <div>
            <Form>
                <Row gutter={[2, 1]}>
                    <Col>
                        <Form.Item>
                            <label>Base Name</label>
                            <Input id="baseName" placeholder='Base Name' defaultValue={currentBaseName} onBlur={onBaseNameChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Interface ID</label>
                            <Input id="interfaceId" type="number" placeholder='Interface ID' defaultValue={currentInterfaceId} onBlur={onInterfaceIdChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Assistance Form ID</label>
                            <Input id="assistanceFormId" type="number" placeholder='Assistance Form ID' defaultValue={currentAssistanceFormId} onBlur={onAssistanceFormIdChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Form Name</label>
                            <Input id="formName" placeholder='Form Name' defaultValue={currentFormName} onBlur={onFormNameChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Form Description</label>
                            <Input id="formDescription" placeholder='Form Description' defaultValue={currentFormDescription} onBlur={onFormDescriptionChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Form Rule Set ID</label>
                            <Input id="formRuleSetId" type="number" placeholder='Form Rule Set ID' defaultValue={currentFormRuleSetId} onBlur={onFormRuleSetIdChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Address Start</label>
                            <Input id="formId" type="number" placeholder='Form ID' defaultValue={currentAddressStart} onBlur={onAddressStartChange} />
                        </Form.Item>
                        <Form.Item>
                            <label>Address End</label>
                            <Input id="formId" type="number" placeholder='Form End ID' defaultValue={currentAddressEnd} onBlur={onAddressEndChange} />
                        </Form.Item>
                        <BusinessRulesViewer />
                    </Col>
                </Row>
            </Form>
        </div>
    return <div>{formDetails}</div>
}

export default FormDetailViewer;